import React from 'react';
import styled from 'styled-components';
import { Seg, SmallButton, RangeText } from './ZetaUi';
import {
  RANGE_PRESETS, presetRange, shiftRange, rangeLabel, dayKey, parseDayKey, dayStart,
} from './zetaUtil';

// 공통 기간 선택 — 빠른 선택(오늘·7일·30일·이번 달) + 시작일~종료일 + ◀ ▶(같은 길이만큼 이동).
//   range = { key, from: Date(자정), to: Date(자정) }. key 가 'custom' 이면 빠른 선택은 꺼진다.

const Box = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  input[type='date'] {
    border: 1px solid #e0e4ea;
    border-radius: 8px;
    padding: 5px 8px;
    font-size: 13px;
    font-family: inherit;
    color: #2c3e50;
    background: #fff;
  }
`;

const ZetaRangePicker = ({ range, onChange, idPrefix = 'zeta' }) => {
  if (!range) return null;
  const today = dayStart(new Date());
  const max = dayKey(today);

  const onDate = (which) => (e) => {
    const d = parseDayKey(e.target.value);
    if (!d) return;
    let from = which === 'from' ? d : range.from;
    let to = which === 'to' ? d : range.to;
    if (to > today) to = today;
    if (from > to) { if (which === 'from') to = from; else from = to; }
    onChange({ key: 'custom', from, to });
  };

  return (
    <Box>
      <Seg role="group" aria-label="빠른 기간 선택">
        {RANGE_PRESETS.map(([k, label]) => (
          <button type="button" key={k} aria-pressed={range.key === k} onClick={() => onChange(presetRange(k))}>{label}</button>
        ))}
      </Seg>
      <SmallButton type="button" aria-label="이전 기간" onClick={() => onChange(shiftRange(range, -1))}>◀</SmallButton>
      <input type="date" id={`${idPrefix}-from`} aria-label="시작일" max={max} value={dayKey(range.from)} onChange={onDate('from')} />
      <span style={{ color: '#868e96' }}>~</span>
      <input type="date" id={`${idPrefix}-to`} aria-label="종료일" max={max} value={dayKey(range.to)} onChange={onDate('to')} />
      <SmallButton type="button" aria-label="다음 기간" disabled={range.to >= today} onClick={() => onChange(shiftRange(range, 1))}>▶</SmallButton>
      <RangeText>{rangeLabel(range)}</RangeText>
    </Box>
  );
};

export default ZetaRangePicker;
